import React, { useEffect } from "react";
import { ApiProvider } from "./providers/ApiProvider";
import { AppRouter } from "./routes";
import apiService from "./services/ApiService";
import "./App.css";

// ✅ Correct import path for LanguageSwitcher
// If your LanguageSwitcher is inside `src/components/`
import LanguageSwitcher from "./components/LanguageSwitcher";

// ✅ Import i18n initialization
import "./i18n";
import { useTranslation } from "react-i18next";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Initialize token from localStorage on app start
    const token = localStorage.getItem("jeptags_token");
    if (token) {
      apiService.setToken(token);
    }

    // ✅ Set default language from localStorage or Vietnamese as default
    const savedLang = localStorage.getItem("lang") || "vi";
    i18n.changeLanguage(savedLang);
  }, [i18n]);

  return (
    <ApiProvider>
      <div className="App" style={{ position: "relative", minHeight: "100vh" }}>
        {/* ✅ Language switcher shown globally on all pages */}
        <LanguageSwitcher />

        {/* ✅ Main app router */}
        <AppRouter />
      </div>
    </ApiProvider>
  );
}

export default App;
